import * as Sentry from "@sentry/react";
import { appSelector } from "@/redux/selectors/app.selector";
import { useSelector } from "@/redux/store";
import { useEffect } from "react";

export const SentryUserIdentifier = () => {
  const user = useSelector(appSelector.user);
  const userId = user?.lassoUserId;
  const email = user?.email;
  const firstName = user?.firstName;
  const lastName = user?.lastName;

  useEffect(() => {
    if (userId) {
      Sentry.setUser({ id: userId, email, username: `${firstName} ${lastName}` });
    } else {
      Sentry.setUser(null);
    }
  }, [userId, email, firstName, lastName]);

  return null;
};
